import { createStore } from 'vuex'

export default createStore({
  state: {
    userInfo: null
  },
  getters: {
  },
  mutations: {
    setUserInfoFunc(state, userInfo) {
      state.userInfo = userInfo;
    }
  },
  actions: {
    setUserInfo({ commit }, userInfo) {
      commit('setUserInfoFunc', userInfo);
    }
  },
  modules: {
  }
})
